import { createSlot } from "./capability";

/** Crash and non-fatal error reporting. `errorReporting.ts` routes uncaught errors here. */
/** @public */
export interface CrashAdapter {
  init(): void;
  setUser(playerId: string | null): void;
  captureException(error: unknown, context?: Record<string, string | number | boolean>): void;
  breadcrumb(message: string, data?: Record<string, string | number | boolean>): void;
}

const unsupported: CrashAdapter = {
  init: () => undefined,
  setUser: () => undefined,
  captureException: () => undefined,
  breadcrumb: () => undefined,
};

/** @public */
export const crash = createSlot<CrashAdapter>("crash", unsupported);
